module.exports = __webpack_public_path__ + "static/KC14-dfe122d84586169dafc0e551630d4a14.png";